module.exports = __webpack_public_path__ + "static/img/qrcode.90a8f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.png
// module id = cgBV
// module chunks = 20